import { CardContent, Skeleton, Typography } from "@mui/material";

type Props = {
  isLoading: boolean;
  isEmpty: boolean;
  contentDisplayType:
    | "scorecard"
    | "plan walkthrough"
    | "image"
    | "dose volume histogram";
  children: React.ReactNode;
};

const CustomCardContent = ({
  children,
  isEmpty,
  contentDisplayType,
  isLoading,
}: Props) => {
  return (
    <CardContent>
      {isLoading && (
        <Skeleton
          variant="rectangular"
          height={100}
          data-testid="loading-skeleton"
        />
      )}
      {!isLoading && isEmpty && (
        <Typography variant="body1">
          No {contentDisplayType} submitted.
        </Typography>
      )}
      {!isLoading && !isEmpty && children}
    </CardContent>
  );
};

export default CustomCardContent;
